var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{staticClass:"backgroundColor",staticStyle:{"padding-left":"10%","padding-right":"5%"}},[_c('router-view',{attrs:{"name":"navigation"}}),_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }